/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceDto
 */
export interface ServiceDto {
    /**
     * 
     * @type {number}
     * @memberof ServiceDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceDto
     */
    price?: number;
    /**
     * G = Grundgeb�hr Reiter, N = Startnummer, H = Unterbringung Pferd, I = Best�tigte Impfung
     * @type {string}
     * @memberof ServiceDto
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceDto
     */
    starterPlate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceDto
     */
    horseHousing?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServiceDto
     */
    sort?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceDto
     */
    horseBaseRate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceDto
     */
    priceLabel?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceDto
     */
    defaultChecked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServiceDto
     */
    maxCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof ServiceDto
     */
    cancellableUntil?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ServiceDto
     */
    addUntil?: Date | null;
}

/**
 * Check if a given object implements the ServiceDto interface.
 */
export function instanceOfServiceDto(value: object): value is ServiceDto {
    return true;
}

export function ServiceDtoFromJSON(json: any): ServiceDto {
    return ServiceDtoFromJSONTyped(json, false);
}

export function ServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'price': json['price'] == null ? undefined : json['price'],
        'type': json['type'] == null ? undefined : json['type'],
        'starterPlate': json['starterPlate'] == null ? undefined : json['starterPlate'],
        'horseHousing': json['horseHousing'] == null ? undefined : json['horseHousing'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'horseBaseRate': json['horseBaseRate'] == null ? undefined : json['horseBaseRate'],
        'priceLabel': json['priceLabel'] == null ? undefined : json['priceLabel'],
        'defaultChecked': json['defaultChecked'] == null ? undefined : json['defaultChecked'],
        'maxCount': json['maxCount'] == null ? undefined : json['maxCount'],
        'cancellableUntil': json['cancellableUntil'] == null ? undefined : (new Date(json['cancellableUntil'])),
        'addUntil': json['addUntil'] == null ? undefined : (new Date(json['addUntil'])),
    };
}

export function ServiceDtoToJSON(json: any): ServiceDto {
    return ServiceDtoToJSONTyped(json, false);
}

export function ServiceDtoToJSONTyped(value?: ServiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'price': value['price'],
        'type': value['type'],
        'starterPlate': value['starterPlate'],
        'horseHousing': value['horseHousing'],
        'sort': value['sort'],
        'horseBaseRate': value['horseBaseRate'],
        'priceLabel': value['priceLabel'],
        'defaultChecked': value['defaultChecked'],
        'maxCount': value['maxCount'],
        'cancellableUntil': value['cancellableUntil'] == null ? undefined : ((value['cancellableUntil'] as any).toISOString()),
        'addUntil': value['addUntil'] == null ? undefined : ((value['addUntil'] as any).toISOString()),
    };
}

